import { render } from "./HeaderCatalog.vue?vue&type=template&id=342b1a62&scoped=true"
import script from "./HeaderCatalog.vue?vue&type=script&lang=js"
export * from "./HeaderCatalog.vue?vue&type=script&lang=js"

import "./HeaderCatalog.vue?vue&type=style&index=0&id=342b1a62&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-342b1a62"],['__file',"webpack-assets/vue/templates/common/header/parts/HeaderCatalog.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "342b1a62"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('342b1a62', __exports__)) {
    api.reload('342b1a62', __exports__)
  }
  
  module.hot.accept("./HeaderCatalog.vue?vue&type=template&id=342b1a62&scoped=true", () => {
    api.rerender('342b1a62', render)
  })

}


export default __exports__